import { mixpanelTrack } from "./mixpanelTrack";

const SECTION = "Landing Pages";

type LandingSubsection =
  | "Get SBC Solver"
  | "Get My Evolutions"
  | "Get My Players";

export const trackLandingPageUpgrade = (subsection: LandingSubsection) =>
  mixpanelTrack("upgrade", {
    section: SECTION,
    subsection,
    context: "cta",
    action_type: "lifecycle",
  });

export const trackObjectivesWaitlistJoin = (form: "hero" | "bottom") =>
  mixpanelTrack("join_waitlist", {
    section: SECTION,
    subsection: "Objectives",
    form,
    context: "cta",
    action_type: "lifecycle",
  });
